module.exports = __webpack_public_path__ + "static/media/CP_2022_03_TI212_bi_couche (1).d2a23675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CP_2022_03_TI212_bi_couche (1).jpg
// module id = 1158
// module chunks = 0